export default __webpack_public_path__ + "static/media/service-center.e37ce012.svg";